export default __webpack_public_path__ + "static/media/girl-working.dcca58dc.svg";